import styled from '@emotion/styled';
import { Box, Typography } from '@mui/material';
import Link from 'next/link';
import { YellowButton } from '@/components/button/button';
import { ExperienceStatus } from '@/generated/graphql';
import { theme } from '@/app/common/providers/theme-provider/theme';
import { config } from '@/config/environment';
import ExperienceViewer from './components/experience-viewer';
import WelcomeToDashboard from './edit/components/welcome-to-dashboard-modal';
import HeaderWave from './svgs/hosting-dashboard-header-wave.svg';

const Background = styled.div`
  background-color: ${theme.palette.common.midPurple};
`;

const Container = styled.div`
  padding: 5rem;
  width: 100%;
  max-width: 1200px;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;
const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  height: auto;
  padding: 0 0 120px 0;
`;
const Title = styled(Typography)`
  font-family: var(--font-cooper-light);
  font-style: normal;
  font-weight: 300;
  font-size: 42px;
  line-height: 112.3%;
  width: 100%;
  text-align: left;
  color: #ffffff;
`;
const HeaderWrapper = styled.div`
  position: relative;
  background-color: ${theme.palette.common.black};
`;
const StyledWave = styled(HeaderWave as any)`
  position: relative;
  top: -1px;
`;
const InnerHeader = styled(Container)`
  position: relative;
  z-index: 10;
  align-items: flex-start;
  padding-bottom: 20px;
`;
const Plus = styled.span`
  font-size: 33px;
  margin-right: 10px;
  font-weight: 500;
`;

const MyExperiences = (): React.ReactElement => {
  const archiveMode = config.platformMode === 'archive';

  return (
    <Background>
      <HeaderWrapper>
        <InnerHeader>
          <Title>Your host dashboard</Title>
          <Box pt={2} />
          {!archiveMode && (
            <Link href="/my-experiences/create">
              <YellowButton href="/my-experiences/create">
                <Plus>+</Plus> Create new experience
              </YellowButton>
            </Link>
          )}
        </InnerHeader>
      </HeaderWrapper>
      <StyledWave />
      <Container>
        <Row>
          <ExperienceViewer title="Active" type={ExperienceStatus.Publish} />
        </Row>
        <Row>
          <ExperienceViewer title="Pending Review" type={ExperienceStatus.PendingReview} />
        </Row>
        <Row>
          <ExperienceViewer title="Draft" type={ExperienceStatus.Draft} />
        </Row>
        <Row>
          <ExperienceViewer title="Unlisted" type={ExperienceStatus.Unlisted} />
        </Row>
      </Container>
      <WelcomeToDashboard />
    </Background>
  );
};

export default MyExperiences;
